module.exports = __webpack_public_path__ + "static/media/qshare-one.433ee975.svg";